<template>
  <form action="">
    <b-loading v-model="isLoading"></b-loading>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">支払い方法の登録</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div id="v2-demo" class="payjs-outer"></div>
        <p class="modal-card-notes">カード番号/年月日（mm/yy）/セキュリティコードの3つをご入力ください。</p>
      </section>
      <footer class="modal-card-foot">
        <div class="button close" @click="$emit('close')">キャンセル</div>
        <div class="button submit" @click="submit()">OK</div>
      </footer>
    </div>
  </form>
</template>

<script>
import { payjp } from '@/utils/payjp';

export default {
  name: 'PaymentMethodFormModal',
  data() {
    return {
      creditCardInfo: {},
      isLoading: false,
      cardElement: null
    };
  },
  mounted() {
    var elements = payjp.elements();
    this.cardElement = elements.create('card');
    this.cardElement.mount('#v2-demo');
  },
  methods: {
    creditInfoChanged(values) {
      this.creditCardInfo = values;
    },
    async submit() {
      try {
        this.isLoading = true;

        var r = await payjp.createToken(this.cardElement);

        const payload = {
          userId: this.$store.state.auth.uid,
          tokenId: r.id
        };

        await this.$store.dispatch('payment/addPaymentMethod', payload);
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          duration: 3000,
          message: "登録に失敗しました。",
          type: 'is-danger'
        });
      }
      this.isLoading = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/modal.scss';
</style>
